import React from "react";
import AboutInfo from "../../../molecules/AboutInfo";
import ResetPasswordCard from "../../../molecules/ResetPasswordCard";
import MusicalAnimatedBackground from "../../../organisms/Background/MusicalAnimatedBackground/MusicalAnimatedBackground";
import "../LoginPage/index.css";

const ResetPasswordPage = () => (
    <div className="login-page">
        <MusicalAnimatedBackground />
        <div className="login-container">
            <ResetPasswordCard />
        </div>
        <AboutInfo />
    </div>
);

export default ResetPasswordPage;
